"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadQRCode = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_qr_code_generator_1 = require("@snapchat/web-qr-code-generator");
const DefaultDownloadQrCode_svg_1 = __importDefault(require("./DefaultDownloadQrCode.svg"));
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const urlUtils_1 = require("../../utils/urlUtils");
/**
 * used for generating QR code for downloading snapchat
 */
function DownloadQRCode(props) {
    const intl = (0, react_intl_1.useIntl)();
    const [qrCodeSvg, setQrCodeSvg] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const qrLinkUrl = (0, urlUtils_1.constructQrLinkUrl)(props.wcid, props.traceId);
        const title = intl.formatMessage({
            id: "NINdwZ",
            defaultMessage: "Scan this QR code",
            description: "QR code to scan with mobile phone",
        });
        const svg = (0, web_qr_code_generator_1.toQrCodeSvg)(qrLinkUrl, "#000", props.backgroundColor, web_qr_code_generator_1.Ecc.MEDIUM, title, 0, 260, 260);
        setQrCodeSvg(svg);
    }, [props.wcid, props.traceId, props.backgroundColor, intl, props.pageType]);
    return qrCodeSvg ? qrCodeSvg : (0, jsx_runtime_1.jsx)(DefaultDownloadQrCode_svg_1.default, {});
}
exports.DownloadQRCode = DownloadQRCode;
//# sourceMappingURL=index.js.map